<template>
  <div><slot></slot></div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { SphereBufferGeometry, Mesh } from 'three'
import { WoozyMaterial } from '../../Reusable/WoozyMaterial.js'

export default {
  mixins: [O3DG2],
  props: {
    envMap: {}
  },
  methods: {
    setup () {
      let geo = new SphereBufferGeometry(10, 64, 64)
      let mat = new WoozyMaterial()
      let mesh = new Mesh(geo, mat)
      this.onLoop(() => {
        mesh.rotation.y += 0.01
        mat.time = window.performance.now() * 0.001
      })
      // mat.blending = MultiplyBlending
      mat.woozy = true
      mat.tCube = this.ctx.cubeCam.envMap
      this.ctx.cubeCam.add(this.o3d)

      this.o3d.position.y = 18
      this.o3d.add(mesh)
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>